module.exports = __webpack_public_path__ + "static/img/decidoc-05.72d0aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-05.png
// module id = 78
// module chunks = 0